import React, { useState } from 'react'
import SecTitleWithIconDesc from '../../components/secTitleWithIconDesc'
import SettingsIcon from '../../../../assets/icons/SettingsIcon'
import { useTheme } from '../../../../middleware/ThemeContext'
import StyledText from '../../../../components/StyledComponents/StyledText'
import StyledInput from '../../../../components/StyledComponents/StyledInput'
import ToggleSwitch from '../../../../components/StyledComponents/StyledToggle'
import { CorporateTheme, Theme } from '../../../../utils/themes'
import styled from 'styled-components'
import { hexToRgba } from '../../../../utils/helper'
import { Button } from '../../../../components/form/Button'
import CookieIcon from '../../../../assets/icons/CookieIcon'
import { WebsiteFormValues } from '../../../../types/types'
import { SkeletonCell } from '../../../../components/SkeletonCell'

const CookieConsent = ({ companyLoading, isResponsive, setSettingConfiguration, settingConfiguration }: { companyLoading?: boolean, isResponsive?: boolean, setSettingConfiguration: React.Dispatch<React.SetStateAction<WebsiteFormValues>>, settingConfiguration: WebsiteFormValues }) => {
    const { theme } = useTheme();
    const [active, setActive] = useState(true);

    const hanldeToggle = (checked: boolean) => {
        setSettingConfiguration(prev => ({ ...prev, cookieEnabled: !settingConfiguration.cookieEnabled }));
    }

    return (
        <div style={{ border: `1px solid ${theme.CorporateTheme.colors.border}`, borderRadius: '10px', padding: '35px 35px', backgroundColor: theme.CorporateTheme.colors.background, width: '100%' }} >
            <div className='d-flex align-items-center justify-content-between'>
                <SecTitleWithIconDesc fontWeight={700} fontSize={isResponsive ? '16px' : '18px'} fontColor={theme.CorporateTheme.colors.primary} descfontSize={isResponsive ? '12px' : '16px'} icon={<SettingsIcon strokeWidth={2.15} size={isResponsive ? 20 : 25} color={theme.CorporateTheme.colors.primary} />} title='Cookie Consent Banner' desc='Configure cookie banner for l3 portal' />
                {companyLoading ? <SkeletonCell height={'18px'} className='rounded-pill' width={"32px"} /> : <ToggleSwitch
                    noPaddingNeeded
                    showTitle={false}
                    checked={settingConfiguration?.cookieEnabled}
                    activeColor={CorporateTheme.colors.count}
                    inactiveColor={CorporateTheme.colors.textSecondary}
                    knobColor={CorporateTheme.colors.background}
                    onChange={hanldeToggle}
                />}
            </div>
            <CardContainer theme={theme}>
                <div className='d-flex align-items-center gap-2'>
                    <div><CookieIcon /></div>
                    <StyledText fontSize={isResponsive ? '14px' : '16px'} fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>We use cookies</StyledText>
                </div>
                <div style={{ padding: "0px 33px" }}>
                    <StyledText fontSize={isResponsive ? '12px' : '14px'} fontWeight={500} textColor={theme.CorporateTheme.colors.headerColor}>We use cookies to personalize your site experience and analyze the site traffic. By clicking Accept all Cookies, you agree to the storing of cookies on your device.</StyledText>
                </div>
                <div className='d-flex justify-content-end gap-2 pt-2 w-100'>
                    <Button
                        theme={theme}
                        btnBg={theme?.CorporateTheme?.colors?.filterBG}
                        color={theme?.CorporateTheme?.colors?.headerColor}
                        $variant="customButton"
                        className="px-3"
                        borderColor="none"
                        radius='3px'
                    >
                        Reject All
                    </Button>
                    <Button
                        theme={theme}
                        btnBg={theme?.CorporateTheme?.colors?.primary}
                        color={theme?.CorporateTheme?.colors?.background}
                        $variant="customButton"
                        className={`px-3`}
                        borderColor="none"
                        radius='3px'
                    >
                        Accept All Cookies
                    </Button>
                </div>
            </CardContainer >
        </div >
    )
}

export const CardContainer = styled.div<{ theme: Theme }>`
  background-color: ${({theme}) => hexToRgba(theme.CorporateTheme.colors.melonYellow, 0.10)};
  border: 1px solid ${({theme}) => hexToRgba(theme.CorporateTheme.colors.melonYellow, 1)}; 
  border-radius: 5px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap:5px;
  margin-top:25px;
`;

export default CookieConsent
